/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Box, Flex, Text } from '@radix-ui/themes';

import { styled, use, useCallback } from 'fierry/react';

import Navigation, { useArg } from 'solis/navigation';

import Slider from 'solis/react/element/slider';


const DEFAULT_COUNT = 9;
const MIN_COUNT = 3;
const MAX_COUNT = 13;


const Caption = styled(Text)`

  letter-spacing: 0.06em;
  text-transform: uppercase;
`;


const OnValueCommit = ([ value ], dispatch) =>
{
  dispatch.replaceArgs({ 'zoneCount': value });
};


export default () =>
{
  const count = useArg('zoneCount') ?? DEFAULT_COUNT;

  const dispatch = use(Navigation.Dispatch);

  const onValueCommit = useCallback(OnValueCommit, [ dispatch ]);

  return (
    <Flex align = 'center' gap = '3'>

      <Caption size = '1' color = 'gray'>Zone Count</Caption>

      <Box style = {{ width: '200px' }}>
        <Slider defaultValue = {[ count ]} min = {MIN_COUNT} max = {MAX_COUNT} onValueCommit = {onValueCommit} />
      </Box>

    </Flex>
  );
};
